import React from 'react';
import { useSelector } from 'react-redux';
import { useLabels, usePrefs } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import { getVehicleName } from '../utils/getVehicleName';
import { LINE_BREAK_PLACEHOLDER } from '../constants/global';

const VehicleName = () => {
	const labels = useLabels();
	const { vehicleName, vehicleNameClasses } = usePrefs();
	const { vehicleData } = useSelector((state) => state);

	const name = getVehicleName(vehicleName, vehicleData, labels);
	const nameArray = name
		.split(new RegExp(LINE_BREAK_PLACEHOLDER))
		.map((n) => n.trim());

	return (
		<h3
			className={setClassNames([
				'spacing-reset',
				...vehicleNameClasses.split(' ')
			])}
		>
			{nameArray.map((n) => {
				return (
					<React.Fragment key={n}>
						<span className="d-block" data-testid="block">
							{n}
						</span>
					</React.Fragment>
				);
			})}
		</h3>
	);
};

export default VehicleName;
